import Svg from '../generated/AddPlayer';
import { Icon, type IconProps } from './Icon';

export const AddPlayerIcon = (props: IconProps) => <Icon component={Svg} name="addPlayer" {...props} />;
